var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V24H3V20H4V23H20V7H14V1H4V17H3V0H15L21 6ZM15 6H19.5L15 1.5V6Z",
    fill: "#F4F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 20,
    height: 9,
    rx: 1,
    fill: "#C600C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7002 8.53125C15.9212 8.48449 16.1507 8.48991 16.3701 8.54785C16.5902 8.60603 16.7914 8.71539 16.9609 8.8623H16.9619C17.1327 9.01047 17.2672 9.19538 17.3594 9.40137C17.4513 9.60675 17.4998 9.83073 17.5 10.0576V12.3467L17.1035 12.4307L13.5 13.1934V18.209L13.4863 18.2217C13.4952 18.3125 13.5 18.4053 13.5 18.5L13.4961 18.6543C13.4158 20.2401 12.1043 21.5 10.5 21.5C8.84402 21.5 7.5 20.1576 7.5 18.5L7.50391 18.3457C7.5844 16.7613 8.89565 15.5 10.5 15.5C10.8513 15.5 11.1875 15.5623 11.5 15.6738V10.6924L11.5059 10.5605C11.531 10.2549 11.6424 9.96054 11.8311 9.7168V9.71582C12.0471 9.43722 12.3532 9.2395 12.7002 9.16602L15.7002 8.53125Z",
    fill: "white",
    stroke: "#C600C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioDark);
export default __webpack_public_path__ + "static/media/audio_dark.b5eee4cbac77c9c594b2f83a5cc84c82.svg";
export { ForwardRef as ReactComponent };